import qs from 'qs'

export default {
    namespaced: true,
    state: {
        popup_open: false,
        popup_title: "Opppps!",
        popup_message: "Something wrong. Try later or contact with site administrator"
    },
    mutations: {
        popup_visibility(state, status) {
            state.popup_open = status;
        },
        set_title(state, title) {
            state.popup_title = title
        },
        set_message(state, message) {
            state.popup_message = message
        }
    },
    actions: {
        async saveUserToNewsletter({commit, state}, email) {
            let params = {
                action: 'save_subscriber_to_freshmail',
                address_email: email,
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(params))
                .then((res) => {
                    commit('popup_visibility', true)
                    commit('set_title', res.data.data.title)
                    commit('set_message', res.data.data.desc)
                }).catch((e) => {
                    console.log(e)
                    commit('popup_visibility', true)
                }).finally()
        }
    },
    getters: {
        is_open: (state) => state.popup_open,
        get_title: (state) => state.popup_title,
        get_message: (state) => state.popup_message
    }
};
